export default __webpack_public_path__ + "static/media/alliance-block.746a1ec1.svg";